import PaymentStatus from "../types/paymentStatus.type";

export const statusNames: Record<string, string> = {
  [PaymentStatus.DRAFT]: "Draft",
  [PaymentStatus.CREATED]: "Created",
  [PaymentStatus.PENDING]: "Pending",
  [PaymentStatus.PROCESSING]: "Processing",
  [PaymentStatus.APPROVED]: "Approved",
  [PaymentStatus.REJECTED]: "Rejected",
  [PaymentStatus.COMPLETED]: "Completed",
  [PaymentStatus.POSTPONED]: "Postponed",
  [PaymentStatus.CONFIRMING]: "Processing",
  [PaymentStatus.CONFIRMED]: "Confirmed",
  [PaymentStatus.REVIEW]: "Review",
  [PaymentStatus.UNDER_MINIMUM]: "Under minimum",
  [PaymentStatus.FAILED]: "Failed",
  [PaymentStatus.CANCELLED]: "Cancelled",
  [PaymentStatus.BLOCKED]: "Blocked",
  [PaymentStatus.SUCCESS]: "Success",
};

export const statusColors: Record<string, string> = {
  [PaymentStatus.DRAFT]: "rgb(145, 148, 150)",
  [PaymentStatus.CREATED]: "rgb(242, 138, 40)",
  [PaymentStatus.PENDING]: "rgb(242, 138, 40)",
  [PaymentStatus.PROCESSING]: "rgb(250, 173, 20)",
  [PaymentStatus.APPROVED]: "rgb(29, 171, 241)",
  [PaymentStatus.REJECTED]: "rgb(236, 51, 51)",
  [PaymentStatus.COMPLETED]: "rgb(24, 184, 83)",
  [PaymentStatus.POSTPONED]: "rgb(242, 138, 40)",
  [PaymentStatus.CONFIRMING]: "rgb(250, 173, 20)",
  [PaymentStatus.CONFIRMED]: "rgb(29, 171, 241)",
  [PaymentStatus.REVIEW]: "rgb(145, 148, 150)",
  [PaymentStatus.UNDER_MINIMUM]: "#F28A28",
  [PaymentStatus.FAILED]: "rgb(236, 51, 51)",
  [PaymentStatus.CANCELLED]: "rgb(145, 148, 150)",
  [PaymentStatus.BLOCKED]: "rgb(255, 255, 255)",
  [PaymentStatus.SUCCESS]: "rgb(24, 184, 83)",
};

export const isEditable = (status: PaymentStatus) =>
  status === "DRAFT" || status === "PENDING";

export const listStatusDeposits = [
  { value: PaymentStatus.REJECTED, label: statusNames[PaymentStatus.REJECTED] },
  {
    value: PaymentStatus.PROCESSING,
    label: statusNames[PaymentStatus.PROCESSING],
  },
  {
    value: PaymentStatus.COMPLETED,
    label: statusNames[PaymentStatus.COMPLETED],
  },
];

export const listStatus = [
  { value: PaymentStatus.PENDING, label: statusNames[PaymentStatus.PENDING] },
  {
    value: PaymentStatus.PROCESSING,
    label: statusNames[PaymentStatus.PROCESSING],
  },
  {
    value: PaymentStatus.CANCELLED,
    label: statusNames[PaymentStatus.CANCELLED],
  },
  { value: PaymentStatus.REJECTED, label: statusNames[PaymentStatus.REJECTED] },
  {
    value: PaymentStatus.COMPLETED,
    label: statusNames[PaymentStatus.COMPLETED],
  },
  { value: PaymentStatus.FAILED, label: statusNames[PaymentStatus.FAILED] },
];

export const listStatusSendMoney = [
  {
    value: PaymentStatus.CREATED,
    label: statusNames[PaymentStatus.CREATED],
  },
  {
    value: PaymentStatus.PENDING,
    label: statusNames[PaymentStatus.PENDING],
  },
  {
    value: PaymentStatus.APPROVED,
    label: statusNames[PaymentStatus.APPROVED],
  },
  {
    value: PaymentStatus.PROCESSING,
    label: statusNames[PaymentStatus.PROCESSING],
  },
  { value: PaymentStatus.REJECTED, label: statusNames[PaymentStatus.REJECTED] },
  {
    value: PaymentStatus.CANCELLED,
    label: statusNames[PaymentStatus.CANCELLED],
  },
  {
    value: PaymentStatus.COMPLETED,
    label: statusNames[PaymentStatus.COMPLETED],
  },
  {
    value: PaymentStatus.FAILED,
    label: statusNames[PaymentStatus.FAILED],
  },
  {
    value: PaymentStatus.POSTPONED,
    label: statusNames[PaymentStatus.POSTPONED],
  },
];

export const listStatusRequestMoney = [
  {
    value: PaymentStatus.PENDING,
    label: statusNames[PaymentStatus.PENDING],
  },
  {
    value: PaymentStatus.APPROVED,
    label: statusNames[PaymentStatus.APPROVED],
  },
  {
    value: PaymentStatus.PROCESSING,
    label: statusNames[PaymentStatus.PROCESSING],
  },
  { value: PaymentStatus.REJECTED, label: statusNames[PaymentStatus.REJECTED] },
  {
    value: PaymentStatus.CANCELLED,
    label: statusNames[PaymentStatus.CANCELLED],
  },
  {
    value: PaymentStatus.COMPLETED,
    label: statusNames[PaymentStatus.COMPLETED],
  },
  {
    value: PaymentStatus.POSTPONED,
    label: statusNames[PaymentStatus.POSTPONED],
  },
];
